function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "47081378-97AB-4145-8982-A1743AE72BCE");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Web site created using create-react-app. Create a New Account Sign In. Thank you for your interest in appliying to American National Unversity.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Admissions",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "anuAdmissionsMobileMenuExpanded",
  transform: "translate(-341.000000, -108.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "mobileNavigation",
  transform: "translate(0.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "row1",
  transform: "translate(0.000000, 77.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M348.666292,12.7225086 L354.721956,6.61753589 C355.315258,6.01986569 354.896194,5 354.057975,5 L341.942001,5 C341.103828,5 340.684718,6.01986569 341.278066,6.61753589 L347.333684,12.7225086 C347.700969,13.0924971 348.299007,13.0924971 348.666292,12.7225086 Z",
  id: "iconSectionContract"
})))));

var SvgTriangle = function SvgTriangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 8",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/triangle.093fc263.svg";
export { ForwardRef as ReactComponent };